import { useRef, useState, type PointerEvent } from 'react';

/**
 * 手寫簽名板:滑鼠 / 觸控 / 平板手寫,輸出 base64 PNG。
 * onChange 在每筆畫結束時回傳目前簽名影像(空白時回傳 '')。
 */
export function SignaturePad({ onChange, height = 150 }: { onChange: (dataUrl: string) => void; height?: number }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const drawing = useRef(false);
  const [dirty, setDirty] = useState(false);

  const ctx = () => canvasRef.current?.getContext('2d') ?? null;
  const pos = (e: PointerEvent<HTMLCanvasElement>) => {
    const r = canvasRef.current!.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  const start = (e: PointerEvent<HTMLCanvasElement>) => {
    e.preventDefault();
    const c = ctx();
    if (!c) return;
    drawing.current = true;
    const p = pos(e);
    c.beginPath();
    c.moveTo(p.x, p.y);
    c.lineWidth = 2;
    c.lineCap = 'round';
    c.strokeStyle = '#1a1a1a';
  };
  const move = (e: PointerEvent<HTMLCanvasElement>) => {
    if (!drawing.current) return;
    const c = ctx();
    if (!c) return;
    const p = pos(e);
    c.lineTo(p.x, p.y);
    c.stroke();
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setDirty(true);
    onChange(canvasRef.current?.toDataURL('image/png') ?? '');
  };
  const clear = () => {
    const cv = canvasRef.current;
    const c = ctx();
    if (cv && c) c.clearRect(0, 0, cv.width, cv.height);
    setDirty(false);
    onChange('');
  };

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={460}
        height={height}
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
        style={{
          width: '100%',
          height,
          border: '1px dashed var(--line)',
          borderRadius: 8,
          background: 'var(--surface)',
          touchAction: 'none',
          cursor: 'crosshair',
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
        <span style={{ fontSize: 11, color: dirty ? 'var(--success)' : 'var(--ink-4)' }}>
          {dirty ? '✓ 已簽名' : '請於上方框內簽名'}
        </span>
        <button type="button" className="btn btn-ghost" style={{ fontSize: 11, padding: '3px 10px' }} onClick={clear}>
          清除重簽
        </button>
      </div>
    </div>
  );
}
